<template>
  <div class="staking">
    <div class="staking-header">
      <div class="staking-nav">
        <img src="../../static/images/svg/posnode-logo-qian.svg" alt="" @click="toUrl('/')">
        <ul>
          <!-- <li @click="toUrl('/campaign')">Campaign</li> -->
          <li @click="scrollPostion">NETWORKS</li>
          <li @click="toUrl('/mission')">MISSION</li>
          <li @click="contactModalShow = true">CONTACT</li>
          <!-- <li @click="toUrl('/staking-fund')">Fund</li> -->
        </ul>
      </div>
    </div>
    <router-view/>
<!--    <footer>
      <ul>
        <li><a href="/">Home</a></li>
        <li><a href="https://www.coinpayu.com" target="_blank">Coinpayu</a> </li>
        &lt;!&ndash; <li>
          <a href="https://www.posnode.com/staking-fund">Fund</a>
        </li> &ndash;&gt;
        <li class="staking-share">
          <a href="https://article.coinpayu.com/@Coinpayu" target="_blank" style="margin: 0;"><img src="../../static/images/share/article.svg"></a>
          <a href="https://www.coinpayu.com/forum" target="_blank" style="margin: 0;"><img src="../../static/images/share/forum.svg"></a>
          <a href="https://twitter.com/CoinPayU" target="_blank" style="margin: 5px;"><img src="../../static/images/share/twitter.svg"></a>
          <a href="https://t.me/CoinpayuStaking" target="_blank" style="margin: 5px;"><img src="../../static/images/share/telegram.svg"></a>
          <a href="https://www.facebook.com/coinpayu" target="_blank" style="margin: 5px;"><img src="../../static/images/share/facebook.svg"></a>
        </li>
      </ul>
    </footer>-->
    <div class="contact-modal" v-if="contactModalShow">
      <div class="contact-box">
        <div class="contact-close"><span @click="contactModalShow = false">✕</span></div>
        <div class="contact-msg">
          <h2>Contact us</h2>
          <p>Contact us to learn more about our products, for feedback or support. <br> Email Us: <a href="mailto:support@posnode.com" target="_blank">support@posnode.com</a> or  <br> Fillout the form below:</p>
          <ul>
            <li>
              <img src="/static/images/index/user.svg" alt="">
              <input type="text" placeholder="Username" v-model="username">
            </li>
            <li>
              <img src="/static/images/index/company.svg" alt="">
              <input type="text" placeholder="Company" v-model="company">
            </li>
            <li>
              <img src="/static/images/index/email.svg" alt="">
              <input type="text" placeholder="Email address" v-model="email">
            </li>
          </ul>
          <textarea placeholder="Message" v-model="content"></textarea>
          <button @click="sendEmail">Send</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  data () {
    return {
      contactModalShow: false,
      username: '',
      company: '',
      email: '',
      content: '',
      apiLock: true
    }
  },
  methods: {
    sendEmail: function () {
      if (this.apiLock && this.username.length > 0 && this.company.length > 0 && this.email.length > 0 && this.content.length > 0) {
        this.apiLock = false
        this.post('https://sa.coinpayu.com/api/crontab/getContact', {
          username: this.username,
          company: this.company,
          email: this.email,
          content: this.content
        }).then((res) => {
          this.apiLock = true
          if (res.code === 1) {
            this.$tip('Send successfully', true)
            this.contactModalShow = false
            this.username = ''
            this.company = ''
            this.email = ''
            this.content = ''
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    toUrl: function (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    scrollPostion: function () {
      if (this.$route.name === 'index') {
        document.getElementsByClassName('staking-services')[0].scrollIntoView({behavior: 'smooth', block: 'start'})
      } else {
        this.$router.push('/')
        setTimeout(() => {
          document.getElementsByClassName('staking-services')[0].scrollIntoView({behavior: 'smooth', block: 'start'})
        }, 300)
      }
    }
  }
}
</script>

<style scoped>
.contact-modal{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  overflow: auto;
}
.contact-box{
  width: 100%;
  max-width: 520px;
  background: #F5F7F7;
  border-radius: 40px;
  margin: 100px auto 0 auto;
  padding: 30px;
}
.contact-close{
  text-align: right;
}
.contact-close span{
  display: inline-block;
  width: 28px;
  height: 28px;
  border: 1px solid #303030;
  border-radius: 50%;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}
.contact-msg h2{
  font-size: 20px;
  font-family: Arial;
  font-weight: bold;
  color: #303030;
}
.contact-msg p{
  font-size: 14px;
  font-family: Arial;
  font-weight: 400;
  color: #666666;
  margin: 15px 0;
}
.contact-msg p a{
  color: #38be87;
}
.contact-msg ul li{
  height: 48px;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px 0px #CDCDCD;
  display: flex;
  align-items: center;
  padding: 0 15px;
}
.contact-msg ul li img{
  width: 16px;
  margin-right: 10px;
}
.contact-msg ul li input{
  flex: 1;
  border: 0;
  outline: 0;
  height: 46px;
}
.contact-msg ul li input::placeholder{
  font-size: 14px;
  font-family: Arial;
  font-weight: 400;
  color: #8E9B8E;
}
.contact-msg textarea{
  width: 100%;
  height: 300px;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px 0px #CDCDCD;
  border: 0;
  outline: 0;
  padding: 20px;
}
.contact-msg textarea::placeholder{
  color: #8E9B8E;
}
.contact-msg button{
  width: 100%;
  height: 48px;
  background: #38BE87;
  box-shadow: 0px 1px 3px 0px #CDCDCD;
  border-radius: 24px;
  margin-top: 20px;
  border: 0;
  outline: 0;
  font-size: 18px;
  font-family: Arial;
  font-weight: 400;
  color: #FFFFFF;
}
.staking-header{
  width: 100%;
  background: #171A17;
  z-index: 9;
}
.staking-nav{
  display: flex;
  justify-content: space-between;
  height: 90px;
  align-items: center;
  padding: 0 100px;
}
.staking-nav img{
  width: 150px;
  height: auto;
  cursor: pointer;
}
.staking-nav ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
}
.staking-nav ul li{
  font-size: 16px;
  font-family: 'PingFangSC-Medium';
  font-weight: 800;
  color: #6F756F;
  margin-left: 30px;
  cursor: pointer;
}
footer{
  background-color: #43494b;
  padding: 20px;
}
footer ul{
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
}
footer ul li a{
  color: #ffffff;
}
footer ul li a:hover{
  color: #ffffff;
}
footer ul .staking-share a{
  margin-left: 22px;
}
footer ul .staking-share img{
  width: 24px;
  height: 24px;
}
@media screen and (max-width: 700px) {
  .staking-nav{
    padding: 0 20px;
  }
}
@media screen and (max-width: 500px) {
  .staking-nav{
    display: block;
  }
  .staking-nav img{
    margin-top: 20px;
  }
  .staking-nav ul{
    margin-top: 10px;
  }
  .staking-nav ul li{
    margin-right: 15px;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index_header.vue